<template>
  <div>
    <DxButton icon="link" @click="showPopUp()" />

    <DxPopup
      v-model:visible="popupVisible"
      :drag-enabled="true"
      :hide-on-outside-click="true"
      :show-close-button="true"
      :show-title="true"
      :resizeEnabled="true"
      width="800"
      height="480"
      title="Batch Detail"
    >
      <DxPosition
        at="bottom"
        my="center"
        v-model:of="positionOf"
        collision="fit"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="center"
        :options="closeButtonOptions"
      />
      <div>
        <!-- Wait for this component to be created our developers are  working on it!! -->

        <LineItemField
          :modelValue="getBatchDetailValue(cellData)"
          :fname="batchDetailfName"
          :modRoute="batchModRoute"
          :def="this.cellData.column"
          isBatchDetail="true"
          slug="admin"
        >
        </LineItemField>

        <!-- <LineItemField
          v-model="cellData.data.rlt_inventorydetail_batchdetail"
          :fname="batchDetailfName"
          :modRoute="batchModRoute"
          :def="this.cellData.column"
          isBatchDetail="true"
          slug="admin"
        >
        </LineItemField> -->
      </div>
    </DxPopup>
  </div>
</template>
<script>
import DxButton from "devextreme-vue/button";
import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";
import LineItemField from "./LineItemDetailComponent.vue";

import notify from "devextreme/ui/notify";

export default {
  props: {
    cellData: {
      type: Object,
      default: () => ({}),
    },
    batchDetailfName: {
      type: String,
      default: "CnslBatchDetail_LineItem",
    },
    batchModRoute: {
      type: String,
      default: "testbatchModRoute ",
    },
    batchDetailModelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    DxButton,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    LineItemField,
  },
  data() {
    return {
      popupVisible: false,
      saveButtonOptions: {
        icon: "save",
        text: "Save",
        onClick: this.saveBatchRelation,
      },
      closeButtonOptions: {
        text: "Close",
        onClick: () => {
          this.popupVisible = false;
        },
      },
    };
  },
  created() {},
  methods: {
    showPopUp() {
      this.popupVisible = true;
    },
    saveBatchRelation() {
      //notify("The button was clicked");
      //onBatchSave
      var obj = {
        cellId: this.cellData.key,
        rowIndex: this.cellData.rowIndex,
        batchData: this.cellData.data.rlt_cnslinventorydetail_cnslbatchdetail,
      };
      console.log(
        "Need to emit batch detail ",
        this.cellData.data.rlt_cnslinventorydetail_cnslbatchdetail
      );
      this.$emit("onBatchSave", obj);

      // this.popupVisible = false;
    },
    getBatchDetailValue(cellData) {
      console.log("Batch Detail batchModRoute  ", this.batchModRoute);

      if (this.batchModRoute.startsWith("cnsl")) {
        return cellData.data.rlt_cnslinventorydetail_cnslbatchdetail; // Set appropriate value
      } else {
        console.log(
          "Batch Detail cellData data ",
          cellData.data.rlt_inventorydetail_batchdetail
        );

        return cellData.data.rlt_inventorydetail_batchdetail; // Default value
      }
    },
  },
  mounted() {
    // this.modelValue = this.cellData.data.rlt_cnslinventorydetail_cnslbatchdetail;
    console.log(
      "Batch Detail modelValue ",
      this.cellData.data.rlt_inventorydetail_batchdetail
    );
    console.log("Batch Detail cellData  ", this.cellData);
    this.getBatchDetailValue(this.cellData);
    //console.log("Batch Detail cellData third  ",this.cellData.column.editorOptions);
  },
  computed: {},
};
</script>
<style scoped>
</style>
<style lang='scss' scoped>
</style>